import { Location } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class RoutingHelpers {

    static instance: RoutingHelpers;

    constructor(
        private http: HttpClient,
        private location: Location) {
            RoutingHelpers.instance = this;
    }

    back() {
        this.location.back();
    }
}